import PT from 'prop-types';

export const PlayerShape = {
  player_id: PT.number,
  player: PT.string,
  fname: PT.string,
  lname: PT.string,
  fpts: PT.number,
  bye: PT.number,
  position: PT.string,
  risk: PT.string,
  team: PT.string,
  team_id: PT.number,
  upside: PT.string,
  writeup: PT.dangerouslySetInnerHTML,
  injured: PT.number,
  injury_type: PT.string,
  headshot: PT.string,
};

export const PlayerPT = PT.shape(PlayerShape);



// WEBPACK FOOTER //
// ./src/app/components/DataTable/PlayerCell/PlayerCell.proptypes.js